import { render, staticRenderFns } from "./AshoreRanking.vue?vue&type=template&id=71a98906&scoped=true"
import script from "./AshoreRanking.vue?vue&type=script&lang=js"
export * from "./AshoreRanking.vue?vue&type=script&lang=js"
import style0 from "../assets/css/ashore.css?vue&type=style&index=0&id=71a98906&prod&scoped=true&lang=css&external"
import style1 from "./AshoreRanking.vue?vue&type=style&index=1&id=71a98906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a98906",
  null
  
)

export default component.exports